export default "__VITE_ASSET__Du93tv85__"